import { useEffect } from 'react';
import { Modal } from '@JohnLewisPartnership/jl-design-system/components/modal/Modal';

export const QuickViewWrapper = ({
  modalTitle,
  onClose,
  pimProductId,
  initialVariantId,
  rawExperiencesHeader,
  analyticsAdditionalInfo,
  config,
}) => {
  const handleQuickViewExit = () => {
    onClose();
  };

  useEffect(() => {
    window.addEventListener('jl.quick-view.exit', handleQuickViewExit);

    return () => {
      window.removeEventListener('jl.quick-view.exit', handleQuickViewExit);
    };
  }, []);

  return (
    <>
      <Modal
        title={modalTitle}
        footer={false}
        isOpen
        onClose={onClose}
        width="extra-large"
        height="fixed"
      >
        <quick-view
          config={config}
          pim-product-id={pimProductId}
          initial-variant-id={initialVariantId}
          experiences-raw-string={rawExperiencesHeader}
          analytics-additional-info={analyticsAdditionalInfo}
        ></quick-view>
      </Modal>
    </>
  );
};
